<template>
    <div class="Logo">
        <router-link to="/about">
            <img src="../assets/LOGO_TAUR-WHITE-TRANSPARENT.png" />
        </router-link>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Logo',
})
</script>

<style lang="scss">
.Logo {
    display: flex;
    margin-bottom: 20px;
    
    img {
        width: 400px;
    }
}
</style>